var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-title flex flex-align-center"},[(_vm.emoji)?_c('p',{staticClass:"emoji"},[_vm._v(_vm._s(_vm.emoji))]):_vm._e(),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }